var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGoldRibbon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91768 8.89234L9.91728 12.3929C9.91728 12.7474 9.51781 12.9547 9.22795 12.7507L7.00053 11.1828L4.77429 12.7506C4.48444 12.9548 4.08488 12.7475 4.08488 12.3929L4.08382 8.89342C4.88269 9.53367 5.89666 9.91663 7.00008 9.91663C8.10412 9.91663 9.11861 9.53324 9.91768 8.89234ZM7.00008 1.16663C9.25524 1.16663 11.0834 2.9948 11.0834 5.24996C11.0834 7.50512 9.25524 9.33329 7.00008 9.33329C4.74492 9.33329 2.91675 7.50512 2.91675 5.24996C2.91675 2.9948 4.74492 1.16663 7.00008 1.16663Z",
    fill: "#EAA800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoldRibbon);
export default __webpack_public_path__ + "static/media/icon-gold-ribbon.3882e42ab87cf7628db190c2234a623b.svg";
export { ForwardRef as ReactComponent };